import React, {
    useState,
    useEffect,
    useRef
} from 'react'

import LoadingIndicator from './loading-indicator';

export default function Iframe(props) {
    const iframeRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        const onMessage = (event) => {
            console.log('event:', event.data.data);

            if (!iframeRef.current) return;

            const sourceWindow = iframeRef.current.contentWindow || iframeRef.current.contentDocument?.defaultView;
            if (event.source !== sourceWindow) return;

            if (typeof event.data === "string" && event.data.startsWith("resize:")) {
                const newHeight = Number(event.data.slice(7));
                if (!isNaN(newHeight)) {
                    setHeight(newHeight + 5); // Extra padding
                }
            }

            if (event.data.data === 'loaded') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }

        };

        window.addEventListener("message", onMessage);
        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);

    return (
        <>
            {props.hasLoader && height === 0 && (
                <LoadingIndicator type="page" />
            )}

            <iframe
                ref={iframeRef}
                name="SpektrixIFrame"
                id="SpektrixIFrame"
                frameBorder="0"
                src={props.url}
                title={props.title}
                style={{ height: height + 'px', minHeight: height + 'px', width: '100%' }}
            />
        </>
    );
}
